import { AnyAction } from 'redux';
import { FilterGroup } from '../Components/ProductFiltering/types/FilterGroup';
import { SortCriteriaState } from '../Components/ProductSorting/types/SortCriteriaState';
import {
  PRODUCT_FILTERING_RECEIVE,
  PRODUCT_FILTERING_SET_SORTING,
  PRODUCT_FILTERING_UPDATE_FILTERS,
  PRODUCT_FILTERING_UPDATE_PENDING,
} from '../constants';

export interface ProductFilteringState {
  subNavigation: any;
  sortCriteria?: SortCriteriaState;
  filters: FilterGroup[];
  navigationTheme: string;
  updatePending?: boolean;
  mcsStructure: any;
  mcsRootPageUrl: any;
  mcsRootPagetitle: any;
  mcsRootPageDescription: any;
  mcsRootPageMetaTitle: any;
}

const defaultState: ProductFilteringState = {
  subNavigation: null,
  sortCriteria: undefined,
  filters: [],
  navigationTheme: 'filter',
  updatePending: false,
  mcsStructure: null,
  mcsRootPageUrl: null,
  mcsRootPagetitle: null,
  mcsRootPageDescription: null,
  mcsRootPageMetaTitle: null,
};

export default (
  state = defaultState,
  action: AnyAction
): ProductFilteringState => {
  const { type, payload } = action;
  switch (type) {
    case PRODUCT_FILTERING_RECEIVE:
      return {
        ...state,
        ...payload,
      };
    case PRODUCT_FILTERING_SET_SORTING:
      const newState = { ...state };
      if (newState.sortCriteria) {
        const currentlySelectedItem = newState.sortCriteria.sortItems.find(
          (s) => s.selected
        );

        // Unset currently selected item
        if (currentlySelectedItem) {
          currentlySelectedItem.selected = false;
        }

        // Find the selected item and set it as selected
        const sortItemIndex =
          newState.sortCriteria.sortItems.indexOf(payload);
        if (sortItemIndex != -1) {
          newState.sortCriteria.sortItems[sortItemIndex].selected = true;
        }
      }
      return {
        ...newState,
      };
    case PRODUCT_FILTERING_UPDATE_FILTERS:
      return {
        ...state,
        filters: payload,
      };
    case PRODUCT_FILTERING_UPDATE_PENDING:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
